import { Injectable } from '@angular/core';

import { LativHttpClient } from '@service/lativ.interceptor';
import { RecordHitsRequest } from '@proto/store/api/store/misc/hits/hits';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HitsRepositoryService {
  constructor(private http: LativHttpClient) {}

  recordHits(req: RecordHitsRequest): Observable<unknown> {
    return this.http.post('v1/hits', RecordHitsRequest.toJSON(req));
  }
}
